import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCLeSRilVxPblvu6cCfp1ZrIgERAzUJL7M",
  authDomain: "gerbo-ai.firebaseapp.com",
  projectId: "gerbo-ai",
  storageBucket: "gerbo-ai.firebasestorage.app",
  messagingSenderId: "402482078403",
  appId: "1:402482078403:web:36cc9a697eaa40de873876",
  measurementId: "G-RTL0CM1B44"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);


